(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stitched-categories"] && !Shopify.designMode) return;
  try {
    
(() => {
  const rootSelector = '[data-stitched-collection-carousel]';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (x, low, high) => Math.min(high, Math.max(low, x));

  function init(root) {
    if (!root || root.dataset.stitchedCollectionReady === 'true') return;
    root.dataset.stitchedCollectionReady = 'true';

    root.querySelectorAll('[data-stitched-product-gallery]').forEach((gallery) => {
      const slides = Array.from(gallery.querySelectorAll('[data-stitched-product-slide]'));
      const dots = Array.from(gallery.querySelectorAll('[data-stitched-product-dot]'));
      const counter = gallery.querySelector('[data-stitched-product-counter]');
      const prev = gallery.querySelector('[data-stitched-product-prev]');
      const next = gallery.querySelector('[data-stitched-product-next]');
      if (slides.length <= 1) return;
      let selected = 0;
      let startPoint = null;
      let suppressClickUntil = 0;

      function show(index) {
        selected = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === selected;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) {
            slide.querySelectorAll('img').forEach((img) => {
              if (img.loading === 'lazy') img.loading = 'eager';
            });
          }
        });
        dots.forEach((dot, i) => {
          const active = i === selected;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (counter) counter.textContent = `${selected + 1} / ${slides.length}`;
      }
      if (prev) prev.addEventListener('click', (event) => {
        event.preventDefault();
        show(selected - 1);
      });
      if (next) next.addEventListener('click', (event) => {
        event.preventDefault();
        show(selected + 1);
      });
      dots.forEach((dot, i) => dot.addEventListener('click', (event) => {
        event.preventDefault();
        show(i);
      }));

      // Horizontal swipes inside the main image change PRODUCTS.
      // Swipes on the card's text area are left to the outer CATEGORY carousel.
      gallery.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) return;
        startPoint = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { passive: true });
      gallery.addEventListener('touchend', (event) => {
        if (!startPoint || event.changedTouches.length !== 1) return;
        const dx = event.changedTouches[0].clientX - startPoint.x;
        const dy = event.changedTouches[0].clientY - startPoint.y;
        startPoint = null;
        if (Math.abs(dx) < 32 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        suppressClickUntil = performance.now() + 450;
        show(selected + (dx < 0 ? 1 : -1));
      }, { passive: true });
      gallery.addEventListener('touchcancel', () => { startPoint = null; }, { passive: true });
      gallery.addEventListener('click', (event) => {
        if (performance.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
    });

    const track = root.querySelector('[data-stitched-category-track]');
    const controls = root.querySelector('[data-stitched-category-controls]');
    if (!track || !controls) return;

    function categoryStep() {
      const card = track.querySelector('[data-stitched-category-card]');
      if (!card) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function buildDots(pageCount) {
      if (controls.childElementCount === pageCount) return;
      controls.replaceChildren();
      for (let i = 0; i < pageCount; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ss-mobile-dots__dot';
        dot.setAttribute('aria-label', `Go to collection ${i + 1} of ${pageCount}`);
        dot.setAttribute('aria-controls', track.id);
        dot.addEventListener('click', () => {
          const max = Math.max(0, track.scrollWidth - track.clientWidth);
          track.scrollTo({
            left: Math.min(max, i * categoryStep()),
            behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
          });
        });
        controls.appendChild(dot);
      }
    }

    function update() {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const step = Math.max(1, categoryStep());
      // Mobile: one page per collection; desktop: one dot per scroll position
      // (two cards can be visible at once, so hide dots when both fit).
      const pageCount = max < 3 ? 0 : Math.round(max / step) + 1;
      controls.hidden = pageCount < 2;
      if (controls.hidden) {
        controls.replaceChildren();
        return;
      }
      buildDots(pageCount);
      const current = clamp(Math.round(track.scrollLeft / step), 0, pageCount - 1);
      Array.from(controls.children).forEach((dot, index) => {
        const active = index === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    let updateScheduled = false;
    track.addEventListener('scroll', () => {
      if (updateScheduled) return;
      updateScheduled = true;
      requestAnimationFrame(() => {
        updateScheduled = false;
        update();
      });
    }, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(track);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }
    update();
  }

  function scan(scope) {
    if (scope.matches && scope.matches(rootSelector)) init(scope);
    scope.querySelectorAll(rootSelector).forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
